import { DetailedHTMLProps, InputHTMLAttributes } from "react"
import { cn } from "@/lib/utils"

export type CheckboxProps = Omit<
	DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
	"type"
>

export const Checkbox = ({ className = "", ...props }: CheckboxProps) => (
	<input
		className={cn(
			className,
			"text-primary-500 focus:ring-primary-500 h-4 w-4 rounded border-gray-300",
		)}
		type="checkbox"
		{...props}
	/>
)
